module.exports = __webpack_public_path__ + "img/preferences.fdf34c74.jpg";